import pubSection from "../../components/pubSection/index.vue";
import articlesSection from "../../components/articlesSection/index.vue";
import newsLetters from "../../components/newsLetters/index.vue";
import partenairesSection from "../../components/partenairesSection/index.vue";
import heroSection from "../../components/heroSection/index.vue";

export default {
  name: "articles",
  components: {
    heroSection,
    pubSection,
    articlesSection,
    newsLetters,
    partenairesSection
  },
  methods: {
    track() {
      this.$gtag.screenview({
        screen_name: 'Articles page',
      })
      this.$gtag.pageview({
        page_path: '/articles',
      })
    }
  }
};
